// The exact reason that should be tracked as a schedule exception on the bundle.
export const RESCHEDULE_EXCEPTION_REASON = "Reschedule exception";

export const UNSUCCESSFUL_OTHER_REASON =
  "Other (type reason manually if not listed)";

// Order matters — surfaced as-is in the "Mark as unsuccessful" dropdown.
export const UNSUCCESSFUL_REASONS = [
  RESCHEDULE_EXCEPTION_REASON,
  "Same slot rebooked",
  "Ops error",
  "Tech issue",
  "Consent/safety concern",
  "Professional no-show",
  "Professional-client mismatch",
  "Session cancelled by professional",
  UNSUCCESSFUL_OTHER_REASON,
] as const;

export type UnsuccessfulReason = (typeof UNSUCCESSFUL_REASONS)[number];
